import { useContext } from "react";
import { ProjectContext } from "./ProjectContext";

export const useProject = () => {
  const context = useContext(ProjectContext);

  return context;
};
